var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M902.4,791.3c153.2-217.4,100.3-524.9-118-685.5C566.2-54.9,264-8.7,110.9,208.7l72,53C308.1,83.8,555.4,46,733.9,177.5c178.5,131.4,221.8,383,96.5,560.9C705.1,916.1,457.9,954,279.3,822.5l-50.5,71.7C447.1,1054.9,749.2,1008.7,902.4,791.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M40.3,386.4L297.9,331L10,119.2L40.3,386.4L40.3,386.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.ff9f841684aaa2f3ca62cad8278e26d1.svg";
export { ForwardRef as ReactComponent };